import React, { useState } from 'react';
import styled from 'styled-components';
import { Range, Direction } from 'react-range';
import theme from '../../UI/theme';

const trackHeight = 20;
const thumbSize = 20;

const Container = styled.div`
    box-sizing: border-box;
`

const Title = styled.div`
    font-size: 14px;
    color: ${theme.colors.textGray};
    font-weight: 500;
    margin-bottom: 15px; 
`;

const Thumb = styled.div`
    height: ${thumbSize}px;
    width: ${thumbSize}px;
    background-color: ${props => props.thumbColor || theme.colors.greenEnergy};
    outline: none;
    box-sizing: border-box;
`

const Track = styled.div`
    box-sizing: border-box;
    margin: 0 ${trackHeight / 2}px;
`

const Mark = styled.div`
    position: relative;
    bottom: -30px;
    /* right: 10px; */
    font-size: 12px;
`

const Label = styled.div`
    position: relative;
    bottom: ${trackHeight - 0}px;
    font-size: 12px;
    text-align: center;
`

const FooterLableContainer = styled.div`
    display: flex;
    justify-content: space-between;
    margin-top: 4px;
`

const FooterLabel = styled.div`
    font-size: 12px;
    color: ${theme.colors.textGray};
`

const SimpleSlider = props => {
    var thumbColor = props.thumbColor;

    const changeHandler = (newValue) => {
        if (props.onChange) {
            props.onChange(newValue);
        }
    }

    const changeCommittedHandler = (newValues) => {
        if (props.onChangeCommitted) {
            props.onChangeCommitted(newValues);
        }
    }
    var step = props.step || 1;
    var min = props.min || 0;
    var max = props.max || 10;
    var values = [props.value];
    var title = props.title || "";
    const rtl = false;
    var marks = props.marks;
    const backgroundColor = props.backgroundColor || theme.colors.darkSpace90;

    return (
        <Container>
            <Title>{title}</Title>

            <Range
                step={step}
                min={min}
                max={max}
                values={values}
                onChange={(values) => {
                    changeHandler(values);
                }}
                onFinalChange={(values) => changeCommittedHandler(values[0])}
                direction={Direction.Right}
                
                renderTrack={({ props, children }) => (
                    <Track
                        onMouseDown={props.onMouseDown}
                        onTouchStart={props.onTouchStart}
                        {...props}
                        style={{
                            ...props.style,
                            height: trackHeight + 'px',
                            width: `calc(100% - ${trackHeight}px)`,
                            backgroundColor: backgroundColor
                        }}
                    >
                        {children}
                    </Track>
                )}
                renderThumb={({ props, value }) => (
                    <Thumb
                        {...props}
                        thumbColor={thumbColor}
                        style={{
                            ...props.style,
                        }}
                    >
                        <Label>{value}</Label>
                    </Thumb>
                    
                )}

                renderMark={({ props, index }) => (
                    <div
                        {...props}
                    >
                    {/*    {index === 0 || index === (MAX / STEP) ? <>
                            <Mark>
                                {index * STEP}%
                            </Mark>
                        </> : <></>} */}
                        {renderMark(marks, index * step + min)}
                    </div>
                )}
            />
            {(props.footerLables && props.footerLables.length > 0) && (
                <FooterLableContainer>
                    {props.footerLables.map((label, index) => (
                        <FooterLabel key={index}>{label}</FooterLabel>
                    ))}
                </FooterLableContainer>
            )}
        </Container>
    );
}

export default SimpleSlider;

const renderMark = (marks, value) => {
    var Component = <></>;
    if (marks && marks.length) {
        var mark = marks.find(mark => mark.value == value);
        if (mark) {
            var Component = <Mark>{mark.label}</Mark>;
        }
    }
    
    return Component;
}

function getThumbColor(props) {
    var thumbColor;
    if (props.thumbColor) {
        thumbColor = props.thumbColor;
    } else if (props.disabled) {
        thumbColor = theme.colors.darkSpace70;
    }
    return thumbColor;
}